import React from 'react'
import Skeleton from '@mui/material/Skeleton';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';


const TableLoadingSkeleton = ({ variant, marginy, marginx, count, height, partial, part }) => {
    return (
        [...Array(count ? count : 1)].map((index, value) => (
            <React.StrictMode key={`table-skeleton-${part}-${value}`} >
                {partial ?
                    <Skeleton key={`table-skeleton-partial-item-${part}-${value}`} variant={variant}
                        sx={{ my: marginy ? marginy : null, mx: marginx ? marginx : null }} height={height ? height : null} />
                    :
                    <TableRow key={`table-skeleton-row-${part}-${value}`} >
                        <TableCell key={`table-skeleton-cell-${part}-${value}`} >
                            <Skeleton key={`table-skeleton-item-${part}-${value}`} variant={variant}
                                sx={{
                                    my: marginy ? marginy : null,
                                    mx: marginx ? marginx : null
                                }}
                                height={height ? height : null} />
                        </TableCell >
                    </TableRow>
                }
            </React.StrictMode>
        )
        )

    )
}

export default TableLoadingSkeleton